"use client";
import { AuthButton } from "@general-components";
import { useRouter } from "next/navigation";
import { ReactNode } from "react";
import { ButtonProps } from "@basic-components";
import { useUserPermission } from "@/hooks/userPermission";

export const LinkButton = ({
  href,
  back,
  children,
  authKey,
  basePath = "/manage",
  show = true,
  ...restProps
}: {
  href?: string;
  back?: boolean;
  children?: ReactNode;
  authKey?: string;
  basePath?: string;
  show?: boolean;
} & ButtonProps) => {
  const router = useRouter();
  const handleClick = () => {
    if (back) {
      router.back();
    } else if (href) {
      const target = href.startsWith(`${basePath}/`) || href === basePath
        ? href
        : `${basePath}${href.startsWith("/") ? href : `/${href}`}`;
      router.push(target);
    }
  };
  const hasPermission = useUserPermission(authKey);

  const handleAuthClick = (e:any) => {
    if (!hasPermission) {
      return ;
    }
    if (restProps.onClick) {
      restProps?.onClick(e);
    } else {
      handleClick();
    }
  }

  if (restProps.type === 'link' && show) {
    return (
      <span
        onClick={handleAuthClick}
        title={!hasPermission ? '暂无权限' : (typeof children === 'string' ? children : '')}
        className={`text-[var(--ant-color-primary)] font-bold hover:text-[var(--ant-color-primary)]/80 max-w-[240px] line-clamp-1 ${!hasPermission ?'cursor-not-allowed text-black/[.25] hover:text-black/[.25]': 'cursor-pointer'}`}
      >
        {children}
      </span>
    );
  }
  
  return (
    <AuthButton
      onClick={handleClick}
      type="primary"
      authKey={authKey}
      {...restProps}
    >
      {back ? children || "返回" : children}
    </AuthButton>
  );
};
